import React from 'react';
import EmailIcon from '@material-ui/icons/Email';
import AppNavButton from './Components/AppNavButton';

const UtilitiesNav = () => {
	return <AppNavButton text="Utilities" showGroupingMenu={false} path="/utilities" icon={<EmailIcon />} />;
};

export default UtilitiesNav;
